@let cabangaLite = cabangaLite$ | async;
@let isMobile = isMobile$ | async;

@if (administrationCredentialsToConfigure$ | async) {
  <app-administration-credentials-banner></app-administration-credentials-banner>
}

<div class="flex flex-column app-root">
  <mat-drawer-container class="flex flex-row app-drawer-container">

    <mat-drawer #drawer
                class="app-drawer"
                ngClass.sm="app-drawer-sm"
                ngClass.xs="app-drawer-xs"
                [style.width]="sideMenuCollapsed ? '72px' : '280px'"
                [style.transition]="isMobile ? '' : 'width 0.3s cubic-bezier(0.4, 0, 0.2, 1)'"
                [mode]="drawerMode()"
                [opened]="drawerOpenDefaultState()">

      <horizon-app-side-menu
        [cabangaLite]="cabangaLite"
        [isSuperAdmin]="isSuperAdmin"
        [isStaffMember]="isStaffMember$ | async"
        [isParent]="isParent$ | async"
        [isStudent]="isStudent$ | async"
        [isAdminStaffMember]="isAdminStaffMember$ | async"
        [isEducatorStaffMember]="isEducatorStaffMember$ | async"
        [schoolSynchronizationEnabled]="schoolSynchronizationEnabled$ | async"
        [elementarySchool]="elementarySchool$ | async"
        [administrationAttendanceAPIIntegrationEnabled]="administrationAttendanceAPIIntegrationEnabled$ | async"
        [isAbsenceJustificationValidationEnabled]="isAbsenceJustificationValidationEnabled$ | async"
        [isMobile]="isMobile"
        [isTeacherStaffMember]="isTeacherStaffMember$ | async"
        [hasAbsenceManagementRole]="hasAbsenceManagementRole$ | async"
        [hasResourceManagementRole]="hasResourceManagementRole$ | async"
        [hasIlpManagementRole]="hasIlpManagementRole$ | async"
        [hasDisciplinaryManagementRole]="hasDisciplinaryManagementRole$ | async"
        [hasStudentManagementRole]="hasStudentManagementRole$ | async"
        [schoolSettings]="schoolSettings$ | async"
        (navigationSelected)="closeDrawer()"
        (collapsedChange)="sideMenuCollapsed = $event"></horizon-app-side-menu>
    </mat-drawer>

    <mat-drawer-content
      [style.marginLeft]="sideMenuCollapsed ? '72px' : isMobile ? '0' : '280px'"
      [style.transition]="'margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1)'">
        <horizon-app-toolbar
          [isMobile]="isMobile$ | async"
          [profiles]="profiles$ | async"
          [selectedProfile]="selectedProfile$ | async"
          [school]="school$ | async"
          (openMenuEvent)="openMenu()"
          (logoutEvent)="logout()"
          (changeProfileEvent)="changeProfile()"
          (goToHelpEvent)="goToHelp()"
          (goToAboutEvent)="goToAbout()"
          (goToOffice365Event)="goToOffice365()"
          (goToGoogleEvent)="goToGoogle($event)"></horizon-app-toolbar>
      <div class="flex flex-column app-content">

        <router-outlet></router-outlet>

      </div>
    </mat-drawer-content>

  </mat-drawer-container>

</div>
